import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRecordPlayInstallReferrerV1Body } from './record-play-install-referrer-v1-request';
import type { IRecordPlayInstallReferrerV1Response } from './record-play-install-referrer-v1-response';
import { recordPlayInstallReferrerV1ResponseSchema } from './record-play-install-referrer-v1-response';

export async function recordPlayInstallReferrerV1Api(
  body: IRecordPlayInstallReferrerV1Body,
): Promise<IValidatedResponse<IRecordPlayInstallReferrerV1Response>> {
  return postRequest<IRecordPlayInstallReferrerV1Response>({
    path: '/account/install-source/play/v1',
    body,
    schema: recordPlayInstallReferrerV1ResponseSchema,
  });
}
